import { render } from "./ShoppingMall.vue?vue&type=template&id=dc8627ba"
import script from "./ShoppingMall.vue?vue&type=script&lang=js"
export * from "./ShoppingMall.vue?vue&type=script&lang=js"

import "./ShoppingMall.vue?vue&type=style&index=0&id=dc8627ba&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__